import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import isEqual from 'react-fast-compare';
import ChannelBox from './channels/ChannelBox';
import AlexaConfigurator from './channels/AlexaConfigurator';
import WhatsappConfigurator from './channels/WhatsappConfigurator';
import ChannelInfo from './channels/ChannelInfo';
import CawiInfo from './channels/CawiInfo';
import WhatsappInfo from './channels/WhatsappInfo';
import FbMessengerInfo from './channels/FbMessengerInfo';
import AlexaInfo from './channels/AlexaInfo';
import ApiInfo from './channels/ApiInfo';
import {generateApiKey} from '../../services/idHelpers';

class ChannelFields extends React.Component {
    constructor(props) {
        super(props);
        this._defaultApikey = generateApiKey();
    }

    shouldComponentUpdate(nextProps) {
        return (this.props.setFieldValue !== nextProps.setFieldValue) ||
            (this.props.surveyId !== nextProps.surveyId) ||
            !isEqual(this.props.values, nextProps.values);
    }

    render() {
        const {setFieldValue, surveyId, values} = this.props;
        return (
            <div className="row mb-0">
                <div className="col-6 mb-3">
                    <ChannelBox channel={constants.CHANNEL_TYPES.CAWI} values={values[constants.CHANNEL_TYPES.CAWI]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <ChannelInfo values={values[constants.CHANNEL_TYPES.CAWI]} channel={constants.CHANNEL_TYPES.CAWI}>
                                <CawiInfo surveyId={surveyId} />
                            </ChannelInfo>
                        </div>
                    </ChannelBox>
                </div>
                <div className="col-6 mb-3">
                    <ChannelBox channel={constants.CHANNEL_TYPES.API} values={values[constants.CHANNEL_TYPES.API]} setFieldValue={setFieldValue}
                        defaultValues={{apiKey: this._defaultApikey}}>
                        <div className="btn-group">
                            <ChannelInfo values={values[constants.CHANNEL_TYPES.API]} channel={constants.CHANNEL_TYPES.API}>
                                <ApiInfo apiKey={values[constants.CHANNEL_TYPES.API] && values[constants.CHANNEL_TYPES.API].apiKey} />
                            </ChannelInfo>
                        </div>
                    </ChannelBox>
                </div>
                <div className="col-12 col-sm-6 col-xl-4 mb-3">
                    <ChannelBox channel={constants.CHANNEL_TYPES.ALEXA} values={values[constants.CHANNEL_TYPES.ALEXA]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <AlexaConfigurator values={values[constants.CHANNEL_TYPES.ALEXA]} setFieldValue={setFieldValue} />
                            <ChannelInfo values={values[constants.CHANNEL_TYPES.ALEXA]} channel={constants.CHANNEL_TYPES.ALEXA}>
                                <AlexaInfo />
                            </ChannelInfo>
                        </div>
                    </ChannelBox>
                </div>
                <div className="col-12 col-sm-6 col-xl-4 mb-3">
                    <ChannelBox channel={constants.CHANNEL_TYPES.FB_MESSENGER} values={values[constants.CHANNEL_TYPES.FB_MESSENGER]}
                        setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <ChannelInfo values={values[constants.CHANNEL_TYPES.FB_MESSENGER]} channel={constants.CHANNEL_TYPES.FB_MESSENGER}>
                                <FbMessengerInfo surveyId={surveyId} />
                            </ChannelInfo>
                        </div>
                    </ChannelBox>
                </div>
                <div className="col-12 col-xl-4 mb-3">
                    <ChannelBox channel={constants.CHANNEL_TYPES.WHATSAPP} values={values[constants.CHANNEL_TYPES.WHATSAPP]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <WhatsappConfigurator values={values[constants.CHANNEL_TYPES.WHATSAPP]} setFieldValue={setFieldValue} />
                            <ChannelInfo values={values[constants.CHANNEL_TYPES.WHATSAPP]} channel={constants.CHANNEL_TYPES.WHATSAPP}>
                                <WhatsappInfo values={values[constants.CHANNEL_TYPES.WHATSAPP]} />
                            </ChannelInfo>
                        </div>
                    </ChannelBox>
                </div>
            </div>
        );
    }
}

export default ChannelFields;
